import FooterModal from "../sections/common/FooterModal";
import InventoryHeader from "../sections/inventory/InventoryHeader";

export default class DocumentFactory {
    static create(props) {
        const completeModal = {
            Header: null,
            Items: null,
            Summary: null,
            Footer: FooterModal,
        }
        switch (props.view) {
            case "transfersRequest":
                completeModal.Header = InventoryHeader
            default:
        }
        return completeModal
    }
}